<script setup>
import { onMounted } from 'vue'

import '@fancyapps/ui/dist/fancybox/fancybox.css'
import * as fancyboxPkg from '@fancyapps/ui'
const { Fancybox } = fancyboxPkg

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import bg from '@/assets/img/thanks/thanks_bg.svg'
import bgElem1 from '@/assets/img/thanks/thanks_bg-elem-1.png'

const bgElems = [{ src: bgElem1, cx: 100, cy: 100, a: 50 }]

const props = defineProps({
	items: {
		type: Array,
		required: true,
		default: () => [],
	},
})

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {
		Hash: false,
		plugins: [],
		placeFocusBack: false, // <-- отключаем возврат фокуса/элемента
		Carousel: {
			Navigation: false,
			Toolbar: {
				display: {
					left: [''],
					right: ['close'],
				},
			},
		},
		animated: false, // <-- полностью отключаем анимацию открытия/закрытия
		showClass: '', // можно убрать fadeIn/fadeOut
		hideClass: '',
	})
})
</script>

<template>
	<section class="thanks" id="thanks">
		<div
			class="thanks__bg"
			v-parallax
			:data-prlx-cx="1000"
			:data-prlx-cy="1000"
			:data-prlx-a="50"
		>
			<img :src="bg" alt="" />
		</div>

		<div
			v-for="(image, index) in bgElems"
			:key="index"
			:class="`thanks__bg-elem thanks__bg-elem-${index + 1}`"
			v-parallax
			:data-prlx-cx="image.cx"
			:data-prlx-cy="image.cy"
			:data-prlx-a="image.a"
			:data-prlx-dxr="image.dxr ? '' : null"
			:data-prlx-dyr="image.dyr ? '' : null"
		>
			<img :src="image.src" alt="" />
		</div>

		<div class="thanks__container">
			<div class="section-header">
				<h2>Благодарности</h2>
			</div>

			<div class="thanks__wrapper">
				<Swiper
					class="thanks__slider"
					:modules="[Navigation]"
					:slides-per-view="5"
					:space-between="0"
					:navigation="{
						prevEl: '.thanks__button-prev',
						nextEl: '.thanks__button-next',
					}"
					:breakpoints="{
						0: {
							slidesPerView: 'auto',
						},
						991.98: {
							slidesPerView: 5,
						},
					}"
				>
					<SwiperSlide v-for="item in props.items" :key="item.id" class="thanks__slide">
						<a :href="item.image" data-fancybox="gallery">
							<img :src="item.image" alt="" />
						</a>
					</SwiperSlide>
				</Swiper>

				<div class="thanks__action">
					<div class="thanks__buttons">
						<button class="arrow-btn thanks__button-prev" type="button">
							<div class="arrow-btn__icon">
								<svg
									viewBox="0 0 100 100"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M62.8328 83.5L28.5 49.5074L61.8379 16.5L71.7657 26.3294L48.0956 49.7655L72.5 73.9287L62.8328 83.5Z"
										fill="#F27699"
									/>
								</svg>
							</div>
							<svg
								class="arrow-btn__shadow"
								preserveAspectRatio="none"
								viewBox="0 0 130 126"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path d="M10 126L0 116.308H120L130 126H10Z" fill="#818B8F" />
								<path
									d="M130 9.70376L120 0L120 116.308L130 126L130 9.70376Z"
									fill="#3A3E40"
								/>
							</svg>
						</button>

						<button class="arrow-btn thanks__button-next" type="button">
							<div class="arrow-btn__icon">
								<svg
									viewBox="0 0 100 100"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M38.1671 16.5L72.5 50.4926L39.1621 83.5L29.2344 73.6706L52.9044 50.2345L28.5 26.0713L38.1671 16.5Z"
										fill="#F27699"
									/>
								</svg>
							</div>

							<svg
								class="arrow-btn__shadow"
								preserveAspectRatio="none"
								viewBox="0 0 130 126"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path d="M10 126L0 116.308H120L130 126H10Z" fill="#818B8F" />
								<path
									d="M130 9.70376L120 0L120 116.308L130 126L130 9.70376Z"
									fill="#3A3E40"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped lang="scss">
.thanks {
	position: relative;
	padding: 10.4rem 0 36.3rem;
	margin: -4rem 0 -8.7rem;

	@media (max-width: 991.98px) {
		padding: 3.6rem 0 2.4rem;
		margin: 0;
	}

	// .thanks__bg
	&__bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: -1;

		@media (max-width: 991.98px) {
			display: none;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	&__bg-elem {
		position: absolute;
		pointer-events: none;
		z-index: 10;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		&-1 {
			width: 37rem;
			height: 37rem;
			top: 8%;
			right: 6.6%;

			@media (max-width: 991.98px) {
				width: 15rem;
				height: 15rem;
				top: auto;
				bottom: -5.5%;
				right: 0;
			}
		}
	}

	// .thanks__container
	&__container {
	}

	&__wrapper {
		margin-top: 14.3rem;
		position: relative;

		@media (max-width: 991.98px) {
			margin-top: 10rem;
		}
	}

	// .thanks__slider
	&__slider {
		padding: 10rem 0;
		margin: -10rem 0;

		@media (max-width: 991.98px) {
			overflow: visible;
			margin: 0;
			padding: 0;
		}
	}

	// .thanks__slide
	&__slide {
		@media (min-width: 991.98px) {
			&:nth-child(even) {
				transform: translateY(-9.1rem);
			}
		}

		@media (max-width: 991.98px) {
			&:nth-child(7n + 1) {
				width: 24.7rem;
				height: 35.7rem;
			}
			&:nth-child(7n + 2) {
				width: 16.2rem;
				height: 23.7rem;
			}
			&:nth-child(7n + 3) {
				width: 16.3rem;
				height: 23.7rem;
				margin-top: 6rem;
			}
			&:nth-child(7n + 4) {
				margin-top: 1.6rem;
				width: 12.2rem;
				height: 17.7rem;
			}
			&:nth-child(7n + 5) {
				margin-top: -7.4rem;
				width: 24.6rem;
				height: 35.8rem;
			}
			&:nth-child(7n + 6) {
				margin-top: -4rem;
				width: 28.2rem;
				height: 40.9rem;
			}
			&:nth-child(7n + 7) {
				margin-top: 3.2rem;
				width: 19.6rem;
				height: 28.4rem;
			}
		}

		a {
			width: 100%;
			height: 100%;
			display: block;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}

	&__action {
		position: absolute;
		bottom: -16.4%;
		right: 0;

		@media (max-width: 991.98px) {
			display: none;
		}
	}

	&__buttons {
		display: flex;
		gap: 3rem;
	}
}
</style>
